import styled from 'styled-components';

import ImageWithAlt from '~/shared/components/ImageWithAlt';
import {getLocalizationService} from '~/shared/services/localisationService';
import warningIcon from '~/assets/images/icons/warningIcon.png';

import {Body, ButtonsContainer, ActionButton, Disclaimer, Subtitle, TextBlock} from '../styled';

const StyledDisclaimer = styled(Disclaimer)`
  width: 300px;
`;

type FailureScreenProps = {
  onRetry: () => void;
};

const FailureScreen = ({onRetry}: FailureScreenProps) => {
  const {t} = getLocalizationService();

  return (
    <Body data-test-id="convertLoyaltyBalanceModal_failureScreen" role="alert">
      <ImageWithAlt src={warningIcon} noAlt />
      <TextBlock>
        <Subtitle id="modal-title">{t('oops_something_went_wrong')}</Subtitle>
        <StyledDisclaimer id="modal-content">{t('tap_and_save_convert_error_subtitle')}</StyledDisclaimer>
      </TextBlock>
      <ButtonsContainer>
        <ActionButton
          variant="primaryLarge"
          data-test-id="convertLoyaltyBalanceModal_retryButton"
          onClick={onRetry}
        >
          {t('tap_and_save_try_again')}
        </ActionButton>
      </ButtonsContainer>
    </Body>
  );
};

export default FailureScreen;
